import {createApp} from 'vue'
import './assets/main.css'
import App from './App.vue'
import router from './router'
import {createPinia} from 'pinia'
import {LoadingPlugin} from 'vue-loading-overlay'
import Vue3Toastify, {type ToastContainerOptions} from 'vue3-toastify'
import { VueQueryPlugin } from '@tanstack/vue-query'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 phút
      }
    }
  }
})

app.use(LoadingPlugin, {
    color: '#50B83C',
    loader: 'dots',
    backgroundColor: '#c3c3c3'
})

// app.filter!('toCurrency', (value: any) => currencyFormat(value))

const options = {
    autoClose: 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    closeOnClick: true,
    transition: 'flip',
    newestOnTop: true,
    theme: "auto"
} as ToastContainerOptions

app.use(Vue3Toastify, options as ToastContainerOptions)

app.mount('#app')